import React from "react"
import styled from "styled-components"
import Flex from "@irati/ui/src/Flex"
import {ButtonLink, ButtonRouterLink} from "@irati/ui/src/Link"
import {H6} from "@irati/ui/src/Typography"
import FormattedMessage, {injectIntl} from "@irati/utils/lang"
import tracking from "@irati-tracking/wallet/rewardPointsWallet"
import CurrentBalanceImage from "@irati-web/wallet/src/images/value_prop_banner.svg"
import IntlMarkdown from "../../styled/IntlMarkdown"
import {LimitedDeal} from "../../campaigns/ChristmasBanner/styled"
import {WalletRoutes} from "@irati-web/wallet/src/enums/Routes"

const LearnMoreWrapper = styled.article`
  ${({theme}) => `
    gap: ${theme.spacing.two};
    background: linear-gradient(87deg, ${theme.colors.primary2} 0%, ${theme.colors.utility.success} 100%);
    border-radius: ${theme.border.radius.large};
    padding: ${theme.spacing.three};
  `}

  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
`

export const LearnMore = injectIntl(function LearnMoreComp({formatMessage}) {
  return (
    <LearnMoreWrapper>
      <Flex direction="column" gap={2} flex="1 1 fit-content">
        <LimitedDeal>
          <H6 as="p">
            <FormattedMessage id="wallet.reward.budget.rewardWallet.upsell.tip" />
          </H6>
        </LimitedDeal>

        <IntlMarkdown white bullets id="wallet.reward.budget.rewardWallet.upsell.body" />

        <Flex gap={2}>
          <ButtonRouterLink
            primary
            id="rewardWalletCreateBudgetButton"
            to={WalletRoutes.FLEXI_BUDGET}
            inverted
            onClick={() => {
              tracking.createBudgets()
            }}>
            <FormattedMessage id="wallet.reward.budget.rewardWallet.cta.createBudget" />
          </ButtonRouterLink>

          <Flex direction="column" justifyContent="center">
            <ButtonLink
              id="rewardWalletBudgetLearnMore"
              tertiary
              inverted
              href={formatMessage({id: "wallet.reward.budget.intercom.learnMore"})}
              target="_blank"
              onClick={() => tracking.learnMore()}>
              <FormattedMessage id="wallet.reward.budget.rewardWallet.cta.discoverBenefits" />
            </ButtonLink>
          </Flex>
        </Flex>
      </Flex>

      <Flex flex="1" justifyContent="center" alignItems="center">
        <div style={{maxWidth: "450px", minWidth: "280px"}}>
          <img src={CurrentBalanceImage} alt="" width="100%" height="auto" />
        </div>
      </Flex>
    </LearnMoreWrapper>
  )
})
